var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"time-line-year"},[_vm._v(_vm._s(_vm.time))]),_c('div',{class:_vm.className},[_vm._v(_vm._s(_vm.year))]),_c('div',{staticClass:"time-line-detail"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }